module.exports = __webpack_public_path__ + "static/media/FLR_Wallpaper02_2560x1600.48174116.jpg";